<template>
    <div class="NotifySetting" :style="`height:${columnH}px`">
        <div class="second-header-wrap">
            <el-button size="medium" @click="saveHandler" type="primary">保存</el-button>
            <el-select v-model="currentNotice" placeholder="请选择" @change="getSchoolInterviewInfoFunc ">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id"
                >
                </el-option>
            </el-select>
        </div>
        <div>
            <div class="header">
                <i class="color-block"></i>
                <span>打印信息面试提醒&nbsp;&nbsp;</span>
                <el-checkbox v-model="listQuery.isPrint"></el-checkbox>
            </div>
            <div class="header">
                <i class="color-block"></i>
                面试提醒信息<span class="important-hint">（面试时间请用{0}表示，请严格按照规则设置）</span>
            </div>
            <div class="content">
                <div class="textarea-container">
                    <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入内容"
                        v-model.trim="listQuery.content"
                    >
                    </el-input>
                </div>
            </div>
            <div class="header">
                <i class="color-block"></i>
                时间安排&nbsp;&nbsp;<el-button class="addTime" @click.native="addTimeline" type="text">+</el-button>
            </div>
            <ul class="ListBox">
                <li v-for="(interviewItem,interviewIndex) in interviewSetList" :key="interviewIndex">
                    <div>{{interviewItem.beginNo}}—{{interviewItem.endNo}}</div>
                    <div>{{interviewItem.beginTime |filterTime}}</div>
                    <div class="font-color"><span @click="delInterview(interviewItem.id)"><i class="el-icon-delete"></i>&nbsp;删除</span>
                    </div>
                </li>
            </ul>
        </div>
        <el-dialog title="添加" :visible.sync="interviewVisible" class="addTimeBox" :close-on-click-modal="false">
            <el-form ref="interviewObject" label-width="100px">
                <el-form-item label="报名序号段" class="numberBox required">
                    <el-input class="beginNo" v-model="diaLogQuery.beginNo" type="number" pattern="[0-9]*" maxlength="8"
                              placeholder="开始序号" oninput="if(value.length>8)value=value.slice(0,8)"></el-input>
                    —
                    <el-input class="endNo" v-model="diaLogQuery.endNo" type="number" pattern="[0-9]*" maxlength="8"
                              placeholder="结束序号" oninput="if(value.length>8)value=value.slice(0,8)"></el-input>
                </el-form-item>
                <el-form-item label=" " class="numberBox" v-if="errorInfo">
                    <span class="error-info" style="color:red">{{errorInfo}}</span>
                </el-form-item>
                <el-form-item label="面试时间" class="numberBox dataWidth">
                    <el-date-picker
                        v-model="intervalYear"
                        type="date"
                        format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                    —
                    <el-time-picker
                        v-model="intervalTime"
                        type="datetime"
                        format="HH:mm"
                        placeholder="选择时间">
                    </el-time-picker>
                    <!-- <el-date-picker
                        v-model="diaLogQuery.beginTime"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="选择日期时间">
                    </el-date-picker>
                    <el-date-picker
                        v-model="diaLogQuery.beginTime"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        placeholder="选择日期时间">
                    </el-date-picker> -->
                </el-form-item>
                <el-form-item label=" " class="numberBox" v-if="errorInfo2">
                    <span class="error-info" style="color:red">{{errorInfo2}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="interviewVisible=false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addTimeHandler()">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import mixins from '@/mixins/windowResize';
    import {
        getSchoolInterviewInfo,
        addAndEditSchoolInterviewTemplet,
        addInterviewTimeSet,
        deleteInterviewTimeSet,
        getSchoolEnrolNoticeList
    } from '@/api/primary/setting';

    export default {
        data() {
            return {
                listQuery: {
                    content: '',
                    isPrint: false,
                    id: ''
                },
                interviewVisible: false,
                diaLogQuery: {
                    beginNo: '',
                    endNo: '',
                    beginTime: ''
                },
                errorInfo: '',
                errorInfo2: '',
                errorInfo4: '',
                interviewSetList: [],
                intervalYear: '',
                intervalTime: '',

                currentNotice: null,
                noticeList: [],
            }
        },
        created() {

            getSchoolEnrolNoticeList({
                searchVal: '',
                state: 2
            })
                .then(res => res.data)
                .then(data => {
                    this.noticeList = data.data;
                    if (data.data.length !== 0) {
                        this.currentNotice = data.data[0].id;
                        this.getSchoolInterviewInfoFunc();
                    }
                })
        },
        mixins: [mixins],
        filters: {
            filterTime(date) {
                return date == '' ? '' : date.slice(0, 16);
            }
        },
        methods: {

            delInterview(id) {
                this.$confirm('您确认删除此时间安排设置吗？', '提示', {type: 'error'}).then(() => {
                    deleteInterviewTimeSet({
                        setId: id
                    }).then(res => res.data)
                        .then(data => {
                            if (data.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.getSchoolInterviewInfoFunc();
                            }
                        })
                }).catch(() => {
                })
            },
            addTimeHandler() {
                let flag = true;
                if(this.noticeList.length === 0) {
                    this.$message({
                        type: 'error',
                        message: '暂无招生公告'
                    });
                    this.interviewVisible = false;
                    return false;
                }
                if (this.diaLogQuery.beginNo == '') {
                    this.errorInfo = '报名起止序号不能为空！';
                    return false;
                }
                if (this.diaLogQuery.endNo == '') {
                    this.errorInfo = '报名起止序号不能为空！';
                    return false;
                }
                if (this.diaLogQuery.beginNo > this.diaLogQuery.endNo) {
                    this.errorInfo = '结束序号必须大于开始序号！';
                    return false;
                } else {
                    this.errorInfo = '';
                }
                if (this.intervalYear == '' || this.intervalTime == '') {
                    this.errorInfo2 = '面试时间不能为空！';
                    return false;
                } else {
                    this.errorInfo2 = '';
                }
                if (flag) {
                    console.log("sss");
                    this.intervalYear = this.$moment(this.intervalYear).format("YYYY-MM-DD");
                    this.intervalTime = this.$moment(this.intervalTime).format("HH:mm");
                    this.diaLogQuery.beginTime = this.intervalYear + " " + this.intervalTime;
                    addInterviewTimeSet({
                        noticeId: this.currentNotice,
                        beginNo: this.diaLogQuery.beginNo,
                        endNo: this.diaLogQuery.endNo,
                        beginTime: this.diaLogQuery.beginTime
                    }).then(res => res.data)
                        .then(data => {
                            if (data.code === 200) {
                                this.interviewVisible = false;
                                this.$message({
                                    type: 'success',
                                    message: '保存成功！'
                                });
                                this.getSchoolInterviewInfoFunc();
                            } else {
                                this.interviewVisible = false;
                                this.$message({
                                    type: 'error',
                                    message: data.msg
                                });
                            }
                        }).catch(res => {
                        this.interviewVisible = false;
                    })
                }
            },

            addTimeline() {
                this.diaLogQuery.beginNo = '';
                this.diaLogQuery.endNo = '';
                this.intervalYear = '';
                this.intervalTime = '';
                this.diaLogQuery.beginTime = "";
                this.interviewVisible = true;
            },
            saveHandler() {
                let flag = true;
                if(this.noticeList.length === 0) {
                    this.$message.error('暂无招生公告！');
                    return false;
                }
                if (this.listQuery.content == '') {
                    this.$message.error('请设置面试提醒信息！');
                    return false;
                }
                if (flag) {
                    console.log("sss", this.listQuery.content, this.listQuery.isPrint);
                    addAndEditSchoolInterviewTemplet({
                        noticeId: this.currentNotice,
                        content: this.listQuery.content,
                        isPrint: this.listQuery.isPrint ? 1 : 0,
                        id: this.listQuery.id
                    }).then(res => res.data)
                        .then(data => {
                            if (data.code === 200) {
                                this.getSchoolInterviewInfoFunc();
                                this.$message({
                                    type: 'success',
                                    message: '保存成功！'
                                });
                                this.interviewVisible = false;
                            }
                        })
                }
            },
            getSchoolInterviewInfoFunc() {
                getSchoolInterviewInfo({
                    noticeId: this.currentNotice
                }).then(res => res.data)
                    .then(data => {
                        if (data.code === 200) {
                            console.log(data.data);
                            this.interviewSetList = data.data.interviewSetList;
                            const interviewTempletInfo = data.data.interviewTempletInfo;
                            if (interviewTempletInfo.content) {
                                this.listQuery.content = interviewTempletInfo.content;
                            }
                            this.listQuery.id = interviewTempletInfo.id;
                            this.listQuery.isPrint = interviewTempletInfo.isPrint ? true : false
                        }
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .second-header-wrap {
        left: 0;
        width: 92%;
        // min-width: 1200px;
        background-color: #fff;
        z-index: 1000;
        padding: 20px 0 0 0;
    }

    .header {
        font-size: 18px;
        //border-bottom: 1px solid #20a0ff;
        width: 250px;

        .color-block {
            @include wh(12px, 12px);
            @include middleIB;
            background-color: #20a0ff;
            margin-right: 5px;
            margin-top: -2px;
        }

        white-space: nowrap;
        margin: 16px 5px 6px 0;
        padding: 0 0 10px 0;

        .addTime {
            font-size: 20px;
            cursor: pointer;
        }
    }

    .important-hint {
        color: #ff0000;

    }

    .textarea-container {
        width: 70%;
        padding-left: 24px;
    }

    .numberBox {
        .el-input {
            width: 44%;
        }
    }

    .dataWidth {
        width: 100%;

        .el-input {
            width: 44%;
        }
    }

    .ListBox {
        width: 100%;
        border-top: 1px solid #DDDDDD;
        margin: 0;
        padding-top: 16px;

        li {
            float: left;
            width: 100%;
            @include clearfix;
            margin-bottom: 20px;

            div {
                display: block;
                width: 33.33%;
                float: left;
                text-align: center;
            }
        }

        .font-color {
            color: #409eff;
            cursor: pointer;
        }
    }
</style>
<style>
    input[type=number] {
        -moz-appearance: textfield;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .errorBox .el-input__inner {
        border: 1px solid red;
    }

    .addTimeBox .required .el-form-item__label:before {
        content: "*";
        font-size: 17px;
        position: relative;
        top: 2px;
        display: inline-block;
        color: #f00;
        margin-right: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/setting/NotifySetting.vue